import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Phone } from "lucide-react";
import { useLead } from "../../context/LeadContext";

export default function StickyCTA() {
  const [visible, setVisible] = useState(false);
  const { requestOfferte } = useLead();

  useEffect(() => {
    const onScroll = () => {
      const form = document.getElementById("offerte");
      const formVisible = form && form.getBoundingClientRect().top < window.innerHeight && form.getBoundingClientRect().bottom > 0;
      setVisible(window.scrollY > window.innerHeight * 0.7 && !formVisible);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <>
          <motion.button
            key="desktop"
            data-testid="sticky-cta-desktop"
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 16 }}
            onClick={() => requestOfferte()}
            className="hidden md:flex fixed bottom-8 right-8 z-40 items-center gap-2 bg-neutral-950 text-white text-sm font-semibold px-6 py-3.5 shadow-2xl hover:bg-neutral-800 transition-colors"
          >
            Firmenofferte anfordern
          </motion.button>

          <motion.div
            key="mobile"
            data-testid="sticky-cta-mobile"
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 40 }}
            className="md:hidden fixed bottom-0 left-0 right-0 z-40 grid grid-cols-2 bg-neutral-950 text-white"
          >
            <button
              data-testid="sticky-cta-mobile-offerte"
              onClick={() => requestOfferte()}
              className="py-4 text-sm font-semibold border-r border-white/15"
            >
              Firmenofferte
            </button>
            <a
              data-testid="sticky-cta-mobile-call"
              href="tel:+41449389090"
              className="py-4 text-sm font-semibold flex items-center justify-center gap-2"
            >
              <Phone size={15} /> Anrufen
            </a>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
}
